document.querySelectorAll('.wwd-mobile-navigation').forEach(menu => {
  const trigger = menu.querySelector('summary');
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) { menu.open = false; trigger.focus(); event.preventDefault(); }
  });
  menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
  matchMedia('(min-width: 761px)').addEventListener('change', event => { if (event.matches) menu.open = false; });
});
